import { render, staticRenderFns } from "./ResetearCampos.vue?vue&type=template&id=f67e67de"
import script from "./ResetearCampos.vue?vue&type=script&lang=js"
export * from "./ResetearCampos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports